import { render, staticRenderFns } from "./ThemePropShell.vue?vue&type=template&id=368e71cd&scoped=true"
import script from "./ThemePropShell.vue?vue&type=script&lang=js"
export * from "./ThemePropShell.vue?vue&type=script&lang=js"
import style0 from "./ThemePropShell.vue?vue&type=style&index=0&id=368e71cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368e71cd",
  null
  
)

export default component.exports